import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
/**
 * A more square-ish button with an icon that shows the icon large with the labeul below it.
 */
export const ColumnIconButton = ({ label, icon: SvgIconComponent, onClick, isDisabled }) => {
    return (_jsx(Button, { onClick: onClick, variant: 'outlined', disabled: !!isDisabled, children: _jsxs(Stack, { direction: 'column', alignItems: 'center', spacing: 0, children: [_jsx(SvgIconComponent, { sx: { fontSize: 36 } }), _jsx(Typography, { variant: 'body2', children: label })] }) }));
};
